import useNetwork from '../../hooks/useNetwork';
import { user_networkId } from '../../utils/query-helpers';

export default function useNetworkFilter() {
  const network = useNetwork();

  return {
    ...user_networkId(network)
  };
};
